<template>
  <div>
    <section class="banner-sec bg bg-9">
      <div class="container">
        <div class="bg-content">
          <div class="box-login">
            <h1 class="lato">Restablecer contraseña</h1>
            <form class="form login-form">    
              <div class="box-success" v-if="respuesta">
                <b>Listo!</b> El password fue restablecido con éxito.
                <router-link to="/login" class="btn-link deco-dotted pull-right">INGRESAR AL SISTEMA</router-link>
              </div>
              <div class="box-error" v-if="errorRequest">
                <b>{{mensaje}}</b>
                <router-link to="/recuperar" class="btn-link deco-dotted pull-right">DEBES GENERAR UN NUEVO CÓDIGO</router-link>
              </div>
              <div class="clearfix"></div>
              <div class="form-group">
                <label>Ingrese el nuevo password</label>
                <input type="password" v-model="password" class="form-control"/>
                <span class="label label-danger" v-if="!$v.password.required && mostrarErrores">Campo requerido</span>
                <span class="label label-danger" v-if="!$v.password.minLength && mostrarErrores">El password debe contener 6 caracteres como mínimo</span>
              </div>
              <div class="form-group">
                <label>Repita el nuevo password</label>
                <input type="password" v-model="repetir" class="form-control"/>
                <span class="label label-danger" v-if="!$v.repetir.sameAs && mostrarErrores">No coincide con el password</span>
              </div>
              <div class="form-action">
                <router-link to="/login" class="btn-link deco-dotted pull-left">¿RECORDASTE TUS DATOS?</router-link>
                <button type="button" class="btn btn-fill btn-lg size-16" @click.prevent="clickEnviar">ENVIAR</button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>
<script>
  import $ from 'jquery'
  import {minLength, required, sameAs} from 'vuelidate/lib/validators'
  export default {
    data () {
      return {
        password: '',
        repetir: '',
        mostrarErrores: false,
        respuesta: false,
        errorRequest: false,
        token: ''
      }
    },
    validations: {
      password: {
        required,
        minLength: minLength(6)
      },
      repetir: {
        sameAs: sameAs('password')
      }
    },
    methods: {
      clickEnviar () {
        const me = this
        me.mostrarErrores = false
        me.mensaje = ''
        me.errorRequest = false
        if (me.$v.password.$invalid || me.$v.repetir.$invalid) {
          me.mostrarErrores = true
          return false
        }
        me.$http.post('/api/users/restablecer', {
          password: me.password,
          repetir: me.repetir,
          token: me.token
        }).then(({body}) => {
          me.email = ''
          me.repetir = ''
          me.respuesta = true
          me.token = ''
        }, (err) => {
          me.errorRequest = true
          me.mensaje = err.body
        })
      }
    },
    created () {
      const me = this
      me.token = me.$route.params.token
    },
    mounted () {
      $('html, body').animate({ scrollTop: 0 }, 'slow')
    }
  }
</script>



// WEBPACK FOOTER //
// Restablecer.vue?b8a870ae